import { Box, useTheme } from '@mui/material'

import { TextParagraph, TextSubTitle } from 'presentation/components/elements'

type RenderListProps = {
  title: string
  listToRender: string[]
}
export default function RenderList({ title, listToRender }: RenderListProps) {
  const theme = useTheme()
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
      <TextSubTitle fontSize="14px" color={theme.palette.secondary.main}>
        {title}
      </TextSubTitle>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
        {listToRender?.map((item: string) => (
          <Box key={item} sx={{ display: 'flex', alignItems: 'flex-start', gap: '5px' }}>
            <Box
              sx={{
                background: theme.mixins.grey.color,
                borderRadius: '50%',
                width: '3px',
                height: '3px',
                marginTop: '8px',
              }}
            />
            <TextParagraph fontSize="14px" color={theme.mixins.grey.color} fontWeight={300}>
              {item}
            </TextParagraph>
          </Box>
        ))}
      </Box>
    </Box>
  )
}
